import {
    TypedUseSelectorHook,
    useDispatch as dispatchHook,
    useSelector as selectorHook
} from "react-redux";
import { TAppDispatch, TRootState } from "../types";

export const useDispatch: () => TAppDispatch = dispatchHook;
export const useSelector: TypedUseSelectorHook<TRootState> = selectorHook;